const getters = {
    sidebar: state => state.app.sidebar,
    msgNum: state => state.app.msgNum,
    globalMessages: state => state.app.globalMessages,
    enableGlobalMessage: state => state.app.enableGlobalMessage,
    token: state => state.user.access_token,
    //avatar: state => state.user.avatar,
    userId: state => state.user.id,
    name: state => state.user.name,
    email: state => state.user.email,
    mobile: state => state.user.mobile,
    allow_routes: state => state.user.allow_routes,
    role_id: state => state.user.role_id,
    cache: state => state.user.cache
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js